import { render, staticRenderFns } from "./UrlDetails.vue?vue&type=template&id=48771fe6&scoped=true&"
import script from "./UrlDetails.vue?vue&type=script&lang=js&"
export * from "./UrlDetails.vue?vue&type=script&lang=js&"
import style0 from "./UrlDetails.vue?vue&type=style&index=0&id=48771fe6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48771fe6",
  null
  
)

export default component.exports